import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Progress } from 'reactstrap';
import { GlobalPrivateState } from 'src/api';
import { Icon } from 'src/app/Partials';

import './ConfigurationHeader.scss';

export interface ConfigurationHeaderProps {
  configuration: GlobalPrivateState['configuration'];
  icon: 'trough' | 'washbasin-dimensions' | 'apron-backsplash' | 'recesses-built-in-parts' | 'paint-palette' | 'wrench' | 'drain-accessories';
  title: string;
  trough: GlobalPrivateState['trough'];
  troughs: GlobalPrivateState['troughs'];
}

export class ConfigurationHeaderPartial extends React.Component<ConfigurationHeaderProps, any> {
  public render() {
    return (
      <div className="partial-configuration-header">
        <div className="row">
          <div className="configuration-heading">
            <Icon name={this.props.icon} size="small" />
            <span>{this.props.title}</span>
            <div className={classNames(
              'configuration-heading-progress',
              'position-absolute', {
                active: this.isUpdating,
              }
            )}>
              <Progress
                animated={true}
                striped={true}
                value="100"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  private get isUpdating(): boolean {
    const {
      configuration,
      trough,
      troughs,
    } = this.props;
    return configuration.updating || trough.updating || troughs.updating;
  }
}

export const ConfigurationHeader = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  trough: state.trough,
  troughs: state.troughs,
}))(ConfigurationHeaderPartial);

export default ConfigurationHeader;